import axios from 'axios';
//import store from '../store';
//import router from '../router';

//const API_URL = 'https://app.erafsolutions.co.za/api';
const API_URL = 'https://dev.erafsolutions.co.za/api';
//const API_URL = 'http://localhost:50463/';
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(
    (a) => a,
    (error) => {
        //if (!error.response) return Promise.reject({response: {data: 'Network Error'}});
        //else if (error && error.response && error.response.status === 401) {
        //    store.dispatch('authentication/logout');
        //    router.push('/');
        //    window.location.replace('/');
        //    //
        //}
        return Promise.reject(error);
    }
);

export const SetBearerToken = function(token) {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
};

export const FilesUrl = API_URL + 'file/';
